var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/IconExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import "@adornis/chemistry/elements/components/x-link.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseIcon } from "../../db/extensions/BaseIcon.js";
import "../RenderableConfigFormController.js";
import "../components/x-buildify-color-picker.js";
import "../components/x-buildify-permission-selection.js";
import "../components/x-buildify-spacing-picker.js";
import "../components/x-infobox.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var IconExtension = {
  class: BaseIcon,
  toolbar: { icon: "star", text: { default: "Icon" } },
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-icon-extension
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-icon-extension>
    `;
  },
  editor({ contentController, controllerBaseKeyPath }) {
    return html`
      <x-flex space="sm">
        <x-infobox>
          Icons können von der Seite
          <x-link href="https://fonts.google.com/icons" ${css({ textDecoration: "underline" })}>
            https://fonts.google.com/icons
          </x-link>
          genommen werden. Der Name der Icons kann einfach als Text eingefügt werden. Dabei müssen alle Buchstaben klein
          geschrieben werden und Leerzeichen durch Unterstriche ersetzt werden. <br />
          Zum Beispiel: Check Circle -> check_circle
        </x-infobox>
        <x-input placeholder="Icon" ${contentController.field(...controllerBaseKeyPath, "icon")}></x-input>
        <x-buildify-color-picker
          placeholder="Farbe"
          ${contentController.field(...controllerBaseKeyPath, "color")}
        ></x-buildify-color-picker>
        <x-buildify-spacing-picker
          placeholder="Größe"
          ${contentController.field(...controllerBaseKeyPath, "size")}
        ></x-buildify-spacing-picker>
      </x-flex>
    `;
  },
  group: "Schriften"
};
var XIconExtension = class extends ExtensionBoilerplate {
  _content(content) {
    return html`
      <x-icon ${css({ color: content.color ?? "#000", fontSize: content.size ?? "24px" })}>
        ${content.icon ? content.icon : "question_mark"}
      </x-icon>
    `;
  }
};
XIconExtension = __decorateClass([
  customElement("x-icon-extension")
], XIconExtension);
var XIconExtensionContentEditor = class extends FormField {
  constructor() {
    super(...arguments);
    this.defaultKeyPath = [];
  }
  render() {
    const controller = this.controller;
    if (!controller || !controller.document)
      return nothing;
    return xComponents(html``);
  }
};
__decorateClass([
  property({ attribute: false })
], XIconExtensionContentEditor.prototype, "defaultKeyPath", 2);
__decorateClass([
  property({ attribute: false })
], XIconExtensionContentEditor.prototype, "controller", 2);
XIconExtensionContentEditor = __decorateClass([
  customElement("x-icon-extension-content-editor")
], XIconExtensionContentEditor);
export {
  IconExtension,
  XIconExtension,
  XIconExtensionContentEditor
};
